var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstorenew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 0.032,
    y2: 511.968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073f6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408.525.032h-305.114c-57.145 0-103.411 46.266-103.411 103.411v305.178c0 57.081 46.266 103.347 103.411 103.347h305.178c57.081 0 103.411-46.266 103.411-103.411v-305.114c-.064-57.145-46.33-103.411-103.475-103.411z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m253.792 117.649 10.367-17.918c6.399-11.199 20.669-14.974 31.868-8.575s14.974 20.669 8.575 31.868l-99.892 172.907h72.247c23.421 0 36.539 27.517 26.365 46.586h-211.813c-12.926 0-23.293-10.367-23.293-23.293s10.367-23.293 23.293-23.293h59.385l76.023-131.76-23.741-41.211c-6.399-11.199-2.624-25.341 8.575-31.868 11.199-6.399 25.341-2.624 31.868 8.575z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.948 366.514-22.397 38.843c-6.399 11.199-20.669 14.974-31.868 8.575s-14.974-20.669-8.575-31.868l16.638-28.796c18.813-5.823 34.107-1.344 46.202 13.246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.819 296.059h60.6c12.926 0 23.293 10.367 23.293 23.293s-10.367 23.293-23.293 23.293h-33.66l22.717 39.419c6.399 11.199 2.624 25.341-8.575 31.868-11.199 6.399-25.341 2.624-31.868-8.575-38.267-66.36-67-116.017-86.069-149.101-19.518-33.66-5.567-67.448 8.191-78.902 15.295 26.237 38.14 65.848 68.664 118.705z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstorenew);
export default __webpack_public_path__ + "static/media/appstorenew.123618bbe29f1e26a426c380e421f70c.svg";
export { ForwardRef as ReactComponent };